<div class="shareContainer">

  <div class="shareModalBox" [ngClass]="{'lowCoins': userData?.coins < 5, 'highCoins': userData?.coins >= 5}">
    <div class="backArrowSection">
      <ion-icon (click)="dismiss()" name="close-outline"></ion-icon>
    </div>
    <div class="imgDiv">
      <img class="vegboost-logo" [src]="srcIconBoost" alt="VegBoost" (error)="onImageError($event)">
    </div>
    <span class="title-share">{{'vegBoost' | translate}}</span>


    <div class="txt-question">
      {{'highlightProfile' | translate}}
    </div>
    <div class="txt-description">
      {{'activateVegBoost' | translate }} <b>12 {{'hours' | translate}}</b>
    </div>
    <br>
    <ion-button class="boostButton button-round" *ngIf="userData?.coins >= 5" (click)="boostMe()">
      {{'boostMe' | translate}}
    </ion-button>
    <ion-button class="purchaseButton button-round" *ngIf="userData?.coins < 5" (click)="openCurrency('VegBoost')">
      {{'buyCarrots' | translate}}
    </ion-button>
    <!-- `?? 0` nos TRES lugares: sem ele, com `coins` indefinido o numero saia em BRANCO
         ("You own  carrots") e nenhuma das duas classes entrava, porque `undefined < 5` e
         `undefined >= 5` sao ambos falsos. Os modais de elogio e de super like ja faziam isso;
         este era o unico sem. -->
    <span class="youOwnClass" [ngClass]="{'lowCoins': (userData?.coins ?? 0) < 5, 'highCoins': (userData?.coins ?? 0) >= 5}">
      {{ 'youOwn' | translate }} {{ userData?.coins ?? 0 }} {{ 'carrots' | translate }}
    </span>
  </div>
</div>